module.exports = __webpack_public_path__ + "img/logo1 (33).f84612eb.jpg";